<style lang="scss" src='./CouponsModal.scss' scoped ></style>
<template src="./CouponsModal.html"></template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";

export default {
  name: 'CouponsModal',
  components: {
    
  },
  data() {
    return {
      showModal: false,
      loadingValidateCoupon: false,
    };
  },
  watch:{
      
    },
  computed: {
    ...mapState(['user', 'showCouponsModal', 'isCheckout']),
    ...mapState("Main", ['categorysList']),
    ...mapGetters("Main", ['getStoreList', 'getCouponsList']),
    ...mapState('CartStore', ['cartProducts']),
  },

  methods: {
    ...mapMutations(['setCouponsModal']),
    ...mapActions('Main', ['fnApiGetAvailableCoupons']),
    ...mapActions('CartStore', ['fnApiAddCoupon']),

    fnGetCouponAmount(coupon){
        if(coupon && coupon.type){
            if(coupon.type == 'PERCENTAGE'){
                return coupon.amount + '%';
            }else{
                return this.F_formatPrice(coupon.amount);
            }
        }
        return false;
    },

    fnGetCategoryDiscount(coupon){
        if(coupon ){
            if(coupon.category_id){
                let cat = this.categorysList.find(x => x.category_id == coupon.category_id);
                return cat ? (this.$t('general.at') + ' ' + cat.label) : '';
            }else{
                return this.$t('coupons.inYourPurchase');
            }
        }
        return '';
    },

    fnGetCustomerRestrictions(coupon){
        if(coupon && coupon.customer_order){
            switch(coupon.customer_order){
                case 'FIRST_ORDER':
                    return this.$t('coupons.restrictionsLabels.FIRST_ORDER');
                case 'PREVIOUS_ORDER':
                    return this.$t('coupons.restrictionsLabels.PREVIOUS_ORDER');
                default:
                    return this.$t('coupons.restrictionsLabels.ALL');
            }
        }
        return false;
    },

    fnGetUsesRestrictions(coupon){
        if(coupon && coupon.single_use){
            return this.$t('coupons.restrictionsLabels.SINGLE_USE');
        }
        return this.$t('coupons.restrictionsLabels.MULTIPLE_USE');
    },

    fnGetDate(date){
        return this.F_formatDateWithString(date + 'Z', 'DD MMMM YYYY');
    },

    fnGerStoreName(coupon){
        if(coupon && coupon.store_id){
            let store = this.getStoreList.find(x => x.store_id == coupon.store_id);
            if(store && store.short_name){
                return this.$t('home.store') + ' ' + store.short_name;
            }
        }
        return false;
    },

    async fnValidateCoupon(coupon) {
        let tempBody = {
            coupon: coupon._id.trim().toUpperCase()
        };
        this.loadingValidateCoupon = true;
        let coupon_added = await this.fnApiAddCoupon(tempBody);
        if(coupon_added){
            this.setCouponsModal(false);
        }
        this.loadingValidateCoupon = false;
    },

    fnIsActiveCoupon(coupon) {
        return this.cartProducts && this.cartProducts.coupon && this.cartProducts.coupon._id == coupon._id;
    },

  },
  beforeCreate() {},
  created() {
    
  },
  mounted() { },
  beforeDestroy() { },
};
</script>